import { TextField, Snackbar, Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../api-interactions/authentication";

export const ResetPassword = () => {
  const [error, setError] = useState();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { token } = useParams();
  const navigate = useNavigate();

  const resetPasswordHandler = (e) => {
    e.preventDefault();
    if (!passwordRef.current.value || !passwordConfirmRef.current.value) {
      return setError("");
    }
    resetPassword(token, {
      password: passwordRef.current.value,
      passwordConfirm: passwordConfirmRef.current.value,
    });

    navigate("/signin");
  };

  return (
    <div>
      {error && (
        <Snackbar open={true} autoHideDuration={6000}>
          <Alert severity="error">{error}</Alert>
        </Snackbar>
      )}
      <form>
        <TextField
          type="password"
          id="password"
          inputRef={passwordRef}
          required
          variant="outlined"
          label="Password"
          className="signin-form-input"
        />
        <TextField
          type="password"
          id="password"
          inputRef={passwordConfirmRef}
          required
          variant="outlined"
          label="Confirm Password"
          className="signin-form-input"
        />
        <Button
          onClick={resetPasswordHandler}
          type="submit"
          variant="contained"
          color="primary"
          id="signin-btn"
        >
          Sign up
        </Button>
      </form>
    </div>
  );
};
